import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { Dropdown, DropdownToggle, DropdownMenu } from "reactstrap";
import { withTranslation } from "react-i18next";
import { connect, useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "../../Common/withRouter";
import LogoutButton from "../../../pages/Google/Auth0/LogoutButton";
import defaultImage from "../../../assets/images/default-profile.png";

const ProfileMenu = (props) => {

  const [menu, setMenu] = useState(false);
  const [name, setName] = useState("");
  const [picture, setPicture] = useState(defaultImage);
  const dispatch = useDispatch();

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data,
    })
  );

  const { token, loading, data } = useSelector(LoginProperties);

  useEffect(() => {
    if (data?.data) {
      setName(data.data.full_name || "");
      setPicture(data.data.picture || defaultImage);
    } else {
      setName("");
      setPicture(defaultImage);
    }
  }, [data]);

  return (
    <Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item"
          id="page-header-user-dropdown"
          tag="button"
        >
          <img
            className="rounded-circle header-profile-user"
            src={picture}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ms-2 me-1">{name}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="custom-dropdown-menu dropdown-menu-end border-0">
          <Link to="/profile" className="dropdown-item">
            <i className="bx bx-user" />
            <span>{props.t("Profile")}</span>
          </Link>
          <div className="dropdown-divider" />
          <LogoutButton />
        </DropdownMenu>
      </Dropdown>
    </Fragment>
  );
};

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
};

const mapStatetoProps = (state) => {
  const { error, success } = state.Profile;
  return { error, success };
};

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
);
